var site = site || {};
site.optionImages = {
	init: function () {
		$('option', 'select.optionImages').each(function() {
			var $this = $(this);
			var $filenameAndLabel = $this.text().split('~');
			$this.text($filenameAndLabel[0]);
			$this.attr('data-image', $filenameAndLabel[1]);
		});

		try {
			$('select.optionImages').msDropDown();
		} catch(e) {
			console.log(e.message);
		}
	}
};
